if (!customElements.get('info-page-accordion')) {
  customElements.define(
    'info-page-accordion',
    class InfoPageAccordion extends HTMLElement {
      constructor() {
        super();
        this.header = this.querySelector('.info-page-accordion__header');
      }

      connectedCallback() {
        this.header.addEventListener('click', () => this.toggle());
      }

      getGroupItems() {
        const group = this.closest('.info-page__accordion-group');
        return group ? group.querySelectorAll('info-page-accordion') : [this];
      }

      open() {
        this.classList.add('info-page-accordion--open');
        this.header.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.classList.remove('info-page-accordion--open');
        this.header.setAttribute('aria-expanded', 'false');
      }

      toggle() {
        this.getGroupItems().forEach((item) => {
          if (item !== this) item.close();
        });

        if (this.classList.contains('info-page-accordion--open')) {
          this.close();
        } else {
          this.open();
        }
      }
    },
  );
}
